var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header orangeToYellow"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.backShow),expression:"backShow"}],staticClass:"s1",on:{"click":function($event){return _vm.goBack()}}},[_c('font',{staticClass:"icon-fanhui iconfont"})],1),_c('span',{staticClass:"s2"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }